import { Section } from './Section';
import { ImageComposition } from '@app/shared/ui/molecules/Instructions';
import {
  firstInstructionSettlement,
  secondInstructionSettlement,
  thirdInstructionSettlement,
} from '@app/assets';

export function ExpandSection() {
  return (
    <Section
      img={
        <ImageComposition
          firstSrc={firstInstructionSettlement}
          firstAlt="first settlement"
          secondSrc={secondInstructionSettlement}
          secondAlt="second settlement"
          thirdSrc={thirdInstructionSettlement}
          thirdAlt="third settlement"
          isSideImagesOpaque
        />
      }
      titleTranslationKey="expand_title"
      descriptionTranslationKey="expand_text"
    />
  );
}
